import Model from "./base/model";

class SimulationOrdersAddresses extends Model {
  resourceName() {
    return "simulation_orders_addresses";
  }

  fields() {
    return {
      simulation_order_id: "",
      address_id: "",
      percentage: "",
      weight_shipping_value: "",
      rates: "",
      simulation_order: { jsonApi: "hasOne", type: "simulation_orders"},
      address: { jsonApi: "hasOne", type: "addresses"},
    };
  }

}

export default new SimulationOrdersAddresses();
